import { render, staticRenderFns } from "./seleccion.vue?vue&type=template&id=89f3ef94&"
import script from "./seleccion.vue?vue&type=script&lang=js&"
export * from "./seleccion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports